<template>
  <div
    id="pageRoot"
    class="backgroundDeaf"
    style="background-color: var(--book-background-color)"
  >
    <img
      id="zorrito"
      class="pageElement basicItem01"
      src="/pages/img/intro/svgZorrito02.svg"
    />
    <div
      class="pageElement text-box-a hover-animation-a"
      id="globe01"
      style="background-image: url(/pages/img/intro/svg03Globe01.svg)"
    >
      <p class="textBase" id="textBox01Text">ESTOS SON MIS AMIGOS:</p>
    </div>

    <img
      id="friends"
      class="pageElement"
      src="/pages/img/intro/svg03Friends.svg"
    />
    <img id="bg" class="pageElement" src="/pages/img/intro/svg03bg.svg" />
  </div>
</template>
<style scoped>
#zorrito {
  position: absolute;
  left: 52px;
  top: 53px;
}
#globe01 {
  position: absolute;
  width: 385.8px;
  height: 156px;
  left: 487px;
  top: 85px;
  z-index: 1;
}
#textBox01Text {
  position: absolute;
  width: 385px;
  left: 0px;
  top: 25px;
  font-size: 26px;
  line-height: 30px;
  text-align: center;
  color: #fbf8f8;
}
#friends {
  position: absolute;
  left: 374px;
  top: 320px;
  z-index: 2;
}
#bg {
  position: absolute;
  left: 103px;
  top: 663px;
  z-index: 1;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p7/V5.mp4"],
    };
  },
};
</script>